<template>
  <el-dialog
    :title="$t('alarmPushRule.bindCcnErrorInfo')"
    :visible.sync="dialogAlarmPushGather"
    :before-close="doClose"
    width="80%"
    top="5%"
    class="abow_dialog"
  >
    <el-form ref="ccnform" :model="ccnform" label-width="100px">
      <div class="DBDiv">
        <div class="tableDiv">
          <el-table
            :data="ccnGatherTable"
            ref="CCNTable"
            @selection-change="handleSelectionChange"
            stripe
            class="formSTable ccntable"
            :empty-text="$t('desc.noData')"
            :height="CCNheight"
          >
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column type="index" :label="$t('title.serialNumber')" width="60">
            </el-table-column>
            <el-table-column
              :label="$t('title.errorCode')"
              prop="returnCode"
              min-width="20%"
            >
            </el-table-column>
            <el-table-column
              :label="$t('title.errorDescription')"
              prop="returnDesc"
              min-width="30%"
            >
            </el-table-column>
            <el-table-column
              :label="$t('title.errorType')"
              prop="returnType"
              min-width="30%"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>

      <el-form-item style="margin-bottom: 0; margin-top: 10px">
        <el-button type="success" :plain="true" v-on:click="onSubBtn">{{
          $t("button.confirm")
        }}</el-button>
        <el-button v-on:click="doClose">{{ $t("button.cancel") }}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { getCcnGatherListById } from "../../../api/api";

export default {
  name: "index",
  props: {
    ccnId: "",
    dialogAlarmPushGather: false,
    gatherReturnIdList: {},
  },
  data() {
    return {
      ccnGatherTable: [],
      CCNheight: "",
      ccnform: {},
      multipleSelection: [],
    };
  },
  watch: {
    dialogAlarmPushGather: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.getCcnGatherListById();
          this.setHeight();
        }
      },
      deep: true,
    },
  },
  created: function () {
    window.onresize = () => {
      this.setHeight();
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    toggleSelection(curReturnList) {
      if (curReturnList) {
        let rows = this.ccnGatherTable.filter((a) =>
          curReturnList.some((x) => x == a.id)
        );
        if (rows) {
          this.$nextTick(() => {
            rows.forEach((row) => {
              this.$refs["CCNTable"].toggleRowSelection(row);
            });
          });
        }
      }
    },
    clearSelection() {
      this.$nextTick(() => {
        this.$refs["CCNTable"].clearSelection();
      });
    },
    async getCcnGatherListById() {
      let res = await getCcnGatherListById(this.ccnId);
      this.ccnGatherTable = res.result;
      this.toggleSelection(this.gatherReturnIdList[this.ccnId]);
    },
    setHeight() {
      let Height = document.documentElement.clientHeight;
      if (Height > 580) {
        this.CCNheight = document.documentElement.clientHeight * 0.95 - 200;
      } else {
        this.CCNheight = 232;
      }
    },
    doClose() {
      this.clearSelection();
      this.$emit("dialogVisibleEvent", false);
      this.ccnGatherTable = new Array();
    },
    onSubBtn() {
      let returnIdList = this.multipleSelection.map((a) => a.id);
      this.$emit("onSubBtn", returnIdList, this.ccnId);
      this.clearSelection();
      this.ccnGatherTable = new Array();
    },
  },
};
</script>
